// An arctic hare, modelled facing +X: a plump white body, short ears (shorter
// than a rabbit's) and big hind feet. Ported 1:1 from age-of-mcp's classic
// arctic-hare.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(0.04, 0), color: "#f4f6f8",
      position: [0, 0.04, 0], scale: [1.1, 1.2, 1] },               // plump body
    { geometry: new THREE.IcosahedronGeometry(0.024, 0), color: "#ffffff",
      position: [0.04, 0.07, 0] },                                   // head
    { geometry: new THREE.BoxGeometry(0.008, 0.03, 0.006), color: "#f0f2f4",
      position: [0.04, 0.1, 0.01], rotation: [0, 0, -0.15] },        // short ear
    { geometry: new THREE.BoxGeometry(0.008, 0.03, 0.006), color: "#f0f2f4",
      position: [0.04, 0.1, -0.01], rotation: [0, 0, -0.15] },
    { geometry: new THREE.IcosahedronGeometry(0.004, 0), color: "#2a2a2a",
      position: [0.058, 0.072, 0.012] },                            // eye
    { geometry: new THREE.IcosahedronGeometry(0.014, 0), color: "#ffffff",
      position: [-0.04, 0.03, 0] },                                  // cotton tail
  ];
}

export const arcticHare = defineModel({
  id: "arctic-hare",
  batchId: "standard",
  name: "Arctic hare",
  tags: ["creature","arctic","hare","low-poly","age-of-mcp","classic"],
  summary: "Low-poly arctic hare.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.07,
  parts: () => partsFor(),
  animations: [],
});
